import { render, staticRenderFns } from "./fee-sheet-rules.vue?vue&type=template&id=0c7fd2fc&"
import script from "./fee-sheet-rules.vue?vue&type=script&lang=ts&"
export * from "./fee-sheet-rules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports